// import React from "react";
// import { Link } from "react-router-dom";

// const Home = () => {
//   return (
//     <div>
//       <section className="hero-wrapper section-padding-3">
//         <div className="container">
//           <div className="row align-items-center">
//             <div className="col-md-12 col-lg-6">
//               <div className="banner-content">
//                 <h2 data-aos="fade-up">
//                   Provide Best IT <br /> Services For Your <br /> Business
//                 </h2>
//                 <Link
//                   to={"/contact"}
//                   className="theme-btn mt-40"
//                   data-aos="fade-up"
//                   data-aos-delay="100"
//                 >
//                   Discover More <i className="icon-arrow-right-1"></i>
//                 </Link>
//               </div>
//             </div>
//             <div className="col-md-12 col-lg-6">
//               <div className="banner-img">
//                 <img src={require("../assets/img/banner-4.png")} alt="banner" />
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="dots-element">
//           <img
//             // src={require("../assets/img/home5/dots_01.svg").default}
//             src="/assets/img/home5/dots_01.svg"
//             alt="dots"
//           />
//         </div>
//         <div className="banner-element ">
//           <img
//             // src={require("../assets/img/home5/object_01.svg").default}
//             src="/assets/img/home5/object_01.svg"
//             alt="object"
//           />
//         </div>
//         <div className="banner-element-2">
//           <img
//             // src={require("../assets/img/home5/banner_02.svg").default}
//             src="/assets/img/home5/banner_02.svg"
//             alt="banner"
//           />
//         </div>
//       </section>
//       <div className="header-gutter"></div>
//       <section className="about-wrapper">
//         <div className="container">
//           <div className="row position-relative">
//             <div
//               className="col-md-12 col-lg-6"
//               data-aos="fade-up"
//               data-aos-delay="100"
//             >
//               <div className="about-img">
//                 <img
//                   src={require("../assets/img/digital-data.png")}
//                   alt="digital-data"
//                 />
//               </div>
//               <div className="img-element">
//                 <img
//                   // src={require("../assets/img/home5/line_dots_01.svg").default}
//                   src="/assets/img/home5/line_dots_01.svg"
//                   alt="line-dots"
//                 />
//               </div>
//             </div>
//             <div
//               className="col-md-12 col-lg-6 mt-30"
//               data-aos="fade-up"
//               data-aos-delay="100"
//             >
//               <div className="section-title section__title_3 mb-30">
//                 <h6>
//                   {/* <img
//                     // src={"/assets/img/home5/bage.svg"}
//                     src="/assets/bage.png
//                     "
//                     alt="bage"
//                   /> */}
//                   What we do
//                 </h6>
//                 <h2>Digital data consulting for your Business Growth</h2>
//               </div>
//               <div className="about-content">
//                 <p>
//                   DNK Software Pvt Ltd is dedicated to staying agile and
//                   adaptable in order to meet the evolving needs of our clients.
//                 </p>
//                 <div className="text">
//                   <p>
//                     We specialize in developing custom software applications
//                   </p>
//                 </div>
//                 <div className="text">
//                   <p>
//                     help businesses streamline their operations and efficiency
//                   </p>
//                 </div>
//                 <a href="#" className="theme-btn mt-40">
//                   Know us more <i className="icon-arrow-right-1"></i>
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>




// {/* 
//       <section className="analytics-wrapper section-padding-3 bg-center bg-cover">
//         <div className="container">
//           <div className="row">
//             <div className="col-12 col-xl-6 col-md-6 offset-md-3 text-center">
//               <div
//                 className="section-title section__title_3 mb-30"
//                 data-aos="fade-up"
//                 data-aos-delay="100"
//               >
//                 <h6>
//                   <img
//                     src={"/assets/img/home5/bage.svg"}
//                     alt="bage"
//                   />
//                   Our Services
//                 </h6>
//                 <h2>Our Proposition Engineering, Analytics and UI Services</h2>
//               </div>
//             </div>
//           </div>
//           <div className="row">
//             <div
//               className="col-lg-4 col-md-6 mt-30"
//               data-aos="fade-up"
//               data-aos-delay="100"
//             >
//               <div className="service-element text-center">
//                 <div className="icon">
//                   <img
//                     // src={require("../assets/img/home5/eng_01.png")}
//                     src="/assets/img/icon/sicon1.png"
//                     alt="eng"
//                   />
//                 </div>
//                 <h4>Product Engineering</h4>
//                 <p>Involves software product development process.</p>
//                 <Link to={"/services"} className="theme-btn">
//                   Read More <i className="far fa-long-arrow-right"></i>
//                 </Link>
//               </div>
//             </div>
//             <div
//               className="col-lg-4 col-md-6 mt-30"
//               data-aos="fade-up"
//               data-aos-delay="150"
//             >
//               <div className="service-element text-center">
//                 <div className="icon">
//                   <img
//                     // src={require("../assets/img/home5/eng_02.png")}
//                     src="/assets/img/icon/sicon2.png"
//                     alt="eng"
//                   />
//                 </div>
//                 <h4>Data Analytics</h4>
//                 <p>
//                   Involves the collection, processing, and analysis of large
//                   data.
//                 </p>
//                 <Link to={"/services"} className="theme-btn">
//                   Read More <i className="far fa-long-arrow-right"></i>
//                 </Link>
//               </div>
//             </div>
//             <div
//               className="col-lg-4 col-md-6 mt-30"
//               data-aos="fade-up"
//               data-aos-delay="200"
//             >
//               <div className="service-element text-center">
//                 <div className="icon">
//                   <img
//                     // src={require("../assets/img/home5/eng_03.png")}
//                     src="/assets/img/icon/sicon3.png"
//                     alt="eng"
//                   />
//                 </div>
//                 <h4>UX/UI Strategy</h4>
//                 <p>
//                   Involves intuitive, engaging, and effective digital
//                   experiences.
//                 </p>
//                 <Link to={"/services"} className="theme-btn">
//                   Read More <i className="far fa-long-arrow-right"></i>
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section> */}





//       <div className="dots-element">
//         <img
//           // src={require("../assets/img/home5/dots_02.svg").default}
//           src="/assets/img/home5/dots_02.svg"
//           alt="dots"
//         />
//       </div>

//       <section className="prosess-wrapper section-padding-3">
//         <div className="container">
//           <div className="row">
//             <div
//               className="col-12 col-xl-6 col-md-6 offset-md-3 text-center"
//               data-aos="fade-up"
//               data-aos-delay="100"
//             >
//               <div className="section-title section__title_3 mb-30">
//                 <h6>
//                   {/* <img
//                     src={"/assets/img/home5/bage.svg"}
//                     alt="bage"
//                   /> */}
//                   Our working process
//                 </h6>
//                 <h2>We Follow 3 steps to Grow Business</h2>
//               </div>
//             </div>
//           </div>
//           <div className="row">
//             <div className="col-12 col-sm-6 col-lg-3 pt-30">
//               <div className="prosess-element text-center">
//                 <div className="icon">
//                   <img
//                     // src={require("../assets/img/home5/icon_01.svg").default}
//                     src="/assets/img/home5/icon_01.svg"
//                     alt="icon"
//                   />
//                 </div>
//                 <h4>Data Analysis</h4>
//                 <p>
//                   Gathering data from various sources, process it with analytics
//                   and display findings.
//                 </p>
//                 <span>Step-1</span>
//               </div>
//             </div>
//             <div className="col-12 col-sm-6 col-lg-3 mt-70 pt-30">
//               <div className="prosess-element text-center">
//                 <div className="icon">
//                   <img
//                     // src={require("../assets/img/home5/icon_02.svg").default}
//                     src="/assets/img/home5/icon_02.svg"
//                     alt="icon"
//                   />
//                 </div>
//                 <h4>Make Idea</h4>
//                 <p>
//                   Create design by checking client needs, target audience with
//                   own thought.
//                 </p>
//                 <span>Step-2</span>
//               </div>
//             </div>
//             <div className="col-12 col-sm-6 col-lg-3 pt-30">
//               <div className="prosess-element text-center ">
//                 <div className="icon">
//                   <img
//                     // src={require("../assets/img/home5/icon_03.svg").default}
//                     src="/assets/img/home5/icon_03.svg"
//                     alt="icon"
//                   />
//                 </div>
//                 <h4>Develop Product</h4>
//                 <p>
//                   Collaborating with developers to ensure design implemented
//                   correctly as per requirements.
//                 </p>
//                 <span>Step-3</span>
//               </div>
//             </div>
//             <div className="col-12 col-sm-6 col-lg-3 mt-40 pt-30">
//               <div className="prosess-element text-center">
//                 <div className="icon">
//                   <img
//                     // src={require("../assets/img/home5/icon_04.svg").default}
//                     src="/assets/img/home5/icon_04.svg"
//                     alt="icon"
//                   />
//                 </div>
//                 <h4>Deliver on Time</h4>
//                 <p>
//                   Launching the product, provide support to ensure that the UX
//                   remains effective and engaging.
//                 </p>
//                 <span>Step-4</span>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="pro-line text-center">
//           <img
//             // src={require("../assets/img/home5/bg_shape_03.svg").default}
//             src="/assets/img/home5/bg_shape_03.svg"
//             alt="bg-shape"
//           />
//         </div>
//       </section>
//       <section className="cta-banner style-3">
//         <div
//           className="container-fluid bg-cover section-bg"
//           style={{ backgroundImage: "../assets/img/cta_bg1.png" }}
//         >
//           <div className="cta-content">
//             <div className="row align-items-center">
//               <div className="col-xl-7 text-white col-12 text-center text-xl-left">
//                 <h1>
//                   Ready To Get Free Consulations For <br /> Any Kind Of IT
//                   Solutions ?{" "}
//                 </h1>
//               </div>
//               <div className="col-xl-5 col-12">
//                 <div className="btn-wraper d-flex flex-wrap justify-content-xl-end mt-2 mt-md-4 mt-xl-0">
//                   <Link to={"/contact"} className="theme-btn">
//                     Get a quote <i className="icon-arrow-right-1"></i>
//                   </Link>
//                   <Link to={"/services"} className="theme-btn">
//                     read more <i className="icon-arrow-right-1"></i>
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Home;

import React from "react";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div className="dnk-home-page">

      {/* =========================================================
          HERO SECTION
      ========================================================= */}

     {/* =========================================================
    HERO SECTION
========================================================= */}

<section className="hero-wrapper section-padding-3 dnk-home-hero">

  <div className="container">
    <div className="row align-items-center">

      {/* =====================================================
          LEFT CONTENT
      ===================================================== */}

      <div className="col-lg-6 col-md-12">

        <div
          className="dnk-new-hero-content"
          data-aos="fade-right"
        >

          <div className="dnk-new-hero-badge">
            SOFTWARE <span>•</span> SERVICES <span>•</span> GLOBAL DELIVERY
          </div>


          <h1 className="dnk-new-hero-title">

            Technology That

            <br />

            <span className="dnk-new-hero-highlight">
              Drives Business
            </span>

            <br />

            Forward.

          </h1>


          {/* <p className="dnk-new-hero-description">

            DNK Software combines product development, custom software
            engineering and offshore technology delivery to help businesses
            solve real problems, improve operations and build for the future.

          </p> */}


          <div className="dnk-new-hero-buttons">

            <Link
              to="/products"
              className="dnk-new-hero-primary"
            >
              Explore Our Products
              <i className="icon-arrow-right-1"></i>
            </Link>


            <Link
              to="/contact"
              className="dnk-new-hero-secondary"
            >
              Talk To Our Team
              <i className="icon-arrow-right-1"></i>
            </Link>

          </div>


          {/* TRUST POINTS */}

          <div className="dnk-new-hero-trust">

            <div>
              <i className="fas fa-check-circle"></i>
              Business-focused
            </div>

            <div>
              <i className="fas fa-check-circle"></i>
              Flexible delivery
            </div>

            <div>
              <i className="fas fa-check-circle"></i>
              Long-term partnership
            </div>

          </div>

        </div>

      </div>


      {/* =====================================================
          RIGHT IMAGE
      ===================================================== */}

      <div className="col-lg-6 col-md-12">

        <div
          className="dnk-new-hero-image"
          data-aos="fade-left"
        >

          <div className="dnk-hero-image-glow"></div>

          <img
            src={require("../assets/img/banner-4.png")}
            alt="DNK Software digital solutions"
          />

        </div>

      </div>

    </div>
  </div>


  {/* =========================================================
      DECORATIVE ELEMENTS
  ========================================================= */}

  <div className="dnk-new-hero-dots">
    <img
      src="/assets/img/home5/dots_01.svg"
      alt=""
    />
  </div>


  <div className="dnk-new-hero-shape">
    <img
      src="/assets/img/home5/object_01.svg"
      alt=""
    />
  </div>


  <div className="dnk-new-hero-shape-two">
    <img
      src="/assets/img/home5/banner_02.svg"
      alt=""
    />
  </div>

</section>


      {/* =========================================================
          COMPANY POSITIONING
      ========================================================= */}

      <section className="dnk-business-pillars section-padding">

        <div className="container">

          <div
            className="row text-center mb-50"
            data-aos="fade-up"
          >

            <div className="col-lg-8 offset-lg-2">

              <div className="section-title section__title_3">

                <h6>
                  WHAT WE DO
                </h6>

                <h2>
                  One Technology Partner.
                  <br />
                  Three Ways To Grow.
                </h2>

              </div>

              <p className="mt-20">
                DNK Software works across the technology lifecycle —
                from creating software products and developing custom
                solutions to extending technology teams through offshore
                delivery.
              </p>

            </div>

          </div>


          <div className="row">

            {/* PRODUCT DEVELOPMENT */}

            <div
              className="col-lg-4 col-md-6 col-12 mt-30"
              data-aos="fade-up"
              data-aos-delay="100"
            >

              <div className="dnk-pillar-card">

                <div className="dnk-pillar-number">
                  01
                </div>

                <div className="dnk-pillar-icon">
                  <i className="fas fa-cubes"></i>
                </div>

                <span className="dnk-pillar-label">
                  BUILD OUR OWN
                </span>

                <h3>
                  Product Development
                </h3>

                <p>
                  We build practical software products that solve
                  everyday business challenges and bring important
                  operations into one connected platform.
                </p>

                <ul>
                  <li>EasyFlow</li>
                  <li>IndusFlow</li>
                  <li>Docparser AI</li>
                </ul>

                <Link to="/products">
                  Explore Products
                  <i className="icon-arrow-right-1"></i>
                </Link>

              </div>

            </div>


            {/* SOFTWARE DEVELOPMENT */}

            <div
              className="col-lg-4 col-md-6 col-12 mt-30"
              data-aos="fade-up"
              data-aos-delay="150"
            >

              <div className="dnk-pillar-card">

                <div className="dnk-pillar-number">
                  02
                </div>

                <div className="dnk-pillar-icon">
                  <i className="fas fa-code"></i>
                </div>

                <span className="dnk-pillar-label">
                  BUILD FOR CLIENTS
                </span>

                <h3>
                  Software Development
                </h3>

                <p>
                  We transform business requirements into reliable
                  digital products, applications and enterprise
                  solutions designed around the people who use them.
                </p>

                <ul>
                  <li>Web & Mobile Applications</li>
                  <li>UI/UX & Digital Experiences</li>
                  <li>Enterprise & Cloud Solutions</li>
                </ul>

                <Link to="/services">
                  Explore Services
                  <i className="icon-arrow-right-1"></i>
                </Link>

              </div>

            </div>


            {/* OFFSHORE */}

            <div
              className="col-lg-4 col-md-6 col-12 mt-30"
              data-aos="fade-up"
              data-aos-delay="200"
            >

              <div className="dnk-pillar-card dnk-pillar-highlight">

                <div className="dnk-pillar-number">
                  03
                </div>

                <div className="dnk-pillar-icon">
                  <i className="fas fa-globe"></i>
                </div>

                <span className="dnk-pillar-label">
                  GLOBAL DELIVERY
                </span>

                <h3>
                  Offshore Technology Partner
                </h3>

                <p>
                  We provide international businesses with software
                  expertise and dedicated technology resources from
                  our delivery team in India.
                </p>

                <ul>
                  <li>Dedicated Developers</li>
                  <li>Extended Technology Teams</li>
                  <li>Remote Project Delivery</li>
                </ul>

                <Link to="/contact">
                  Discuss Partnership
                  <i className="icon-arrow-right-1"></i>
                </Link>

              </div>

            </div>

          </div>

        </div>

      </section>


      

      {/* =========================================================
          PRODUCTS
      ========================================================= */}

      <section className="dnk-products-home section-padding-3">

        <div className="container">

          <div
            className="row text-center mb-50"
            data-aos="fade-up"
          >

            <div className="col-lg-8 offset-lg-2">

              <div className="section-title section__title_3">

                <h6>
                  OUR PRODUCTS
                </h6>

                <h2>
                  Software Built For
                  <br />
                  Real Business Needs.
                </h2>

              </div>

              <p className="mt-20">
                Our products are designed to simplify business management,
                manufacturing operations and intelligent document workflows.
              </p>

            </div>

          </div>


          <div className="row">


            {/* EASYFLOW */}

            <div
              className="col-lg-4 col-md-6 col-12 mt-30"
              data-aos="fade-up"
              data-aos-delay="100"
            >

              <div className="dnk-home-product-card">

                <div className="dnk-home-product-image">

                  <img
                    src={require("../assets/img/products/easyflow-dashboard.png")}
                    alt="EasyFlow business management software"
                  />

                </div>

                <div className="dnk-home-product-content">

                  <span>
                    BUSINESS MANAGEMENT
                  </span>

                  <h3>
                    EasyFlow
                  </h3>

                  <p>
                    Manage projects, tasks, teams, leads and quotations
                    from one connected business workspace.
                  </p>

                  <Link to="/products/easyflow">
                    View Product
                    <i className="icon-arrow-right-1"></i>
                  </Link>

                </div>

              </div>

            </div>


            {/* INDUSFLOW */}

            <div
              className="col-lg-4 col-md-6 col-12 mt-30"
              data-aos="fade-up"
              data-aos-delay="150"
            >

              <div className="dnk-home-product-card">

                <div className="dnk-home-product-image">

                  <img
                    src={require("../assets/img/products/crm-dashboard.png")}
                    alt="IndusFlow manufacturing software"
                  />

                </div>

                <div className="dnk-home-product-content">

                  <span>
                    MANUFACTURING
                  </span>

                  <h3>
                    IndusFlow
                  </h3>

                  <p>
                    Monitor machines, production, inventory and workforce
                    through a centralized manufacturing platform.
                  </p>

                  <Link to="/products/crm">
                    View Product
                    <i className="icon-arrow-right-1"></i>
                  </Link>

                </div>

              </div>

            </div>


            {/* DOCPARSER */}

            <div
              className="col-lg-4 col-md-6 col-12 mt-30"
              data-aos="fade-up"
              data-aos-delay="200"
            >

              <div className="dnk-home-product-card">

                <div className="dnk-home-product-image">

                  <img
                    src={require("../assets/img/products/ai-dashboard.png")}
                    alt="Docparser AI software"
                  />

                </div>

                <div className="dnk-home-product-content">

                  <span>
                    AI SOLUTIONS
                  </span>

                  <h3>
                    Docparser AI
                  </h3>

                  <p>
                    Automate document processing and turn unstructured
                    information into useful business insights.
                  </p>

                  <Link to="/products/ai-solutions">
                    View Product
                    <i className="icon-arrow-right-1"></i>
                  </Link>

                </div>

              </div>

            </div>

          </div>


          <div
            className="text-center mt-50"
            data-aos="fade-up"
          >

            <Link
              to="/products"
              className="theme-btn"
            >
              Explore All Products
              <i className="icon-arrow-right-1"></i>
            </Link>

          </div>

        </div>

      </section>


      {/* =========================================================
          SERVICES
      ========================================================= */}

      <section className="analytics-wrapper section-padding-3 dnk-services-home">

        <div className="container">

          <div
            className="row text-center mb-50"
            data-aos="fade-up"
          >

            <div className="col-lg-8 offset-lg-2">

              <div className="section-title section__title_3">

                <h6>
                  OUR SERVICES
                </h6>

                <h2>
                  Engineering The Right
                  <br />
                  Solution For Your Business.
                </h2>

              </div>

              <p className="mt-20">
                From digital experiences to enterprise platforms,
                our services help businesses move ideas from concept
                to reliable software.
              </p>

            </div>

          </div>


          <div className="row">


            {/* WEB & MOBILE */}

            <div
              className="col-lg-4 col-md-6 col-12 mt-30"
              data-aos="fade-up"
              data-aos-delay="100"
            >

              <div className="service-element text-center dnk-service-card">

                <div className="icon">

                  <i className="fas fa-laptop-code"></i>

                </div>

                <h4>
                  Web & Mobile Development
                </h4>

                <p>
                  Responsive and scalable applications designed
                  around your business goals and users.
                </p>

                <Link to="/services">
                  Explore Service
                  <i className="far fa-long-arrow-right"></i>
                </Link>

              </div>

            </div>


            {/* UI UX */}

            <div
              className="col-lg-4 col-md-6 col-12 mt-30"
              data-aos="fade-up"
              data-aos-delay="150"
            >

              <div className="service-element text-center dnk-service-card">

                <div className="icon">

                  <i className="fas fa-pencil-ruler"></i>

                </div>

                <h4>
                  UI/UX & Digital Experience
                </h4>

                <p>
                  Intuitive interfaces and user experiences that
                  connect design with business objectives.
                </p>

                <Link to="/services">
                  Explore Service
                  <i className="far fa-long-arrow-right"></i>
                </Link>

              </div>

            </div>


            {/* ENTERPRISE */}

            <div
              className="col-lg-4 col-md-6 col-12 mt-30"
              data-aos="fade-up"
              data-aos-delay="200"
            >

              <div className="service-element text-center dnk-service-card">

                <div className="icon">

                  <i className="fas fa-building"></i>

                </div>

                <h4>
                  Enterprise & Cloud Solutions
                </h4>

                <p>
                  Technology solutions that help organizations
                  improve operations, collaboration and scalability.
                </p>

                <Link to="/services">
                  Explore Service
                  <i className="far fa-long-arrow-right"></i>
                </Link>

              </div>

            </div>

          </div>


          <div
            className="text-center mt-50"
            data-aos="fade-up"
          >

            <Link
              to="/services"
              className="theme-btn"
            >
              View All Services
              <i className="icon-arrow-right-1"></i>
            </Link>

          </div>

        </div>

      </section>


      {/* =========================================================
          OFFSHORE PARTNERSHIP
      ========================================================= */}

      <section className="dnk-offshore-section section-padding">

        <div className="container">

          <div className="row align-items-center">


            {/* VISUAL */}

            <div
              className="col-lg-6 col-md-12"
              data-aos="fade-right"
            >

              <div className="dnk-offshore-visual">

                <div className="dnk-offshore-circle"></div>

                <div className="dnk-offshore-box">

                  <span>
                    GLOBAL TECHNOLOGY PARTNERSHIP
                  </span>

                  <div className="dnk-offshore-location">

                    <div className="dnk-location-item">

                      <i className="fas fa-map-marker-alt"></i>

                      <strong>
                        INDIA
                      </strong>

                      <small>
                        Technology Delivery
                      </small>

                    </div>


                    <div className="dnk-offshore-arrow">
                      →
                    </div>


                    <div className="dnk-location-item">

                      <i className="fas fa-globe-africa"></i>

                      <strong>
                        SOUTH AFRICA
                      </strong>

                      <small>
                        Business Partnership
                      </small>

                    </div>

                  </div>

                </div>

              </div>

            </div>


            {/* CONTENT */}

            <div
              className="col-lg-6 col-md-12 mt-40 mt-lg-0"
              data-aos="fade-left"
            >

              <div className="section-title section__title_3 mb-30">

                <h6>
                  OFFSHORE TECHNOLOGY DELIVERY
                </h6>

                <h2>
                  Extend Your
                  <br />
                  Technology Team.
                </h2>

              </div>


              <p>
                DNK Software can work as an extended technology partner
                for international businesses looking for software
                development expertise, technical resources and flexible
                delivery support.
              </p>

              <p>
                Our team in India can support application development,
                product engineering, maintenance and technology projects
                while your business stays focused on its core objectives.
              </p>


              <div className="dnk-offshore-points">

                <div>
                  <i className="fas fa-check"></i>
                  Dedicated technology resources
                </div>

                <div>
                  <i className="fas fa-check"></i>
                  Flexible project engagement
                </div>

                <div>
                  <i className="fas fa-check"></i>
                  Software development support
                </div>

                <div>
                  <i className="fas fa-check"></i>
                  Long-term technology partnership
                </div>

              </div>


              <Link
                to="/contact"
                className="theme-btn mt-30"
              >
                Discuss Offshore Partnership
                <i className="icon-arrow-right-1"></i>
              </Link>

            </div>

          </div>

        </div>

      </section>


      {/* =========================================================
          HOW WE WORK
      ========================================================= */}

      <section className="prosess-wrapper section-padding-3 dnk-process-home">

        <div className="container">

          <div
            className="row"
            data-aos="fade-up"
          >

            <div className="col-xl-7 col-lg-8 col-md-10 offset-md-1 offset-lg-2 offset-xl-2 text-center">

              <div className="section-title section__title_3 mb-30">

                <h6>
                  HOW WE WORK
                </h6>

                <h2>
                  From Idea To
                  <br />
                  Business Impact.
                </h2>

              </div>

              <p>
                A simple and collaborative process keeps every project
                aligned with your business objectives.
              </p>

            </div>

          </div>


          <div className="row">


            {/* STEP 1 */}

            <div className="col-lg-3 col-md-6 col-12 pt-30">

              <div
                className="prosess-element text-center"
                data-aos="fade-up"
              >

                <div className="icon">

                  <img
                    src="/assets/img/home5/icon_01.svg"
                    alt="Discover"
                  />

                </div>

                <span>
                  STEP 01
                </span>

                <h4>
                  Discover
                </h4>

                <p>
                  Understand the business challenge, users,
                  requirements and expected outcomes.
                </p>

              </div>

            </div>


            {/* STEP 2 */}

            <div className="col-lg-3 col-md-6 col-12 pt-30">

              <div
                className="prosess-element text-center"
                data-aos="fade-up"
                data-aos-delay="100"
              >

                <div className="icon">

                  <img
                    src="/assets/img/home5/icon_02.svg"
                    alt="Plan and design"
                  />

                </div>

                <span>
                  STEP 02
                </span>

                <h4>
                  Plan & Design
                </h4>

                <p>
                  Define the solution, experience, architecture
                  and delivery roadmap.
                </p>

              </div>

            </div>


            {/* STEP 3 */}

            <div className="col-lg-3 col-md-6 col-12 pt-30">

              <div
                className="prosess-element text-center"
                data-aos="fade-up"
                data-aos-delay="150"
              >

                <div className="icon">

                  <img
                    src="/assets/img/home5/icon_03.svg"
                    alt="Build and test"
                  />

                </div>

                <span>
                  STEP 03
                </span>

                <h4>
                  Build & Test
                </h4>

                <p>
                  Develop, integrate and test the solution with
                  continuous communication and feedback.
                </p>

              </div>

            </div>


            {/* STEP 4 */}

            <div className="col-lg-3 col-md-6 col-12 pt-30">

              <div
                className="prosess-element text-center"
                data-aos="fade-up"
                data-aos-delay="200"
              >

                <div className="icon">

                  <img
                    src="/assets/img/home5/icon_04.svg"
                    alt="Launch and support"
                  />

                </div>

                <span>
                  STEP 04
                </span>

                <h4>
                  Launch & Support
                </h4>

                <p>
                  Deploy the solution, support your team and
                  continue improving the product.
                </p>

              </div>

            </div>

          </div>

        </div>


        <div className="pro-line text-center">

          <img
            src="/assets/img/home5/bg_shape_03.svg"
            alt="process line"
          />

        </div>

      </section>


      {/* =========================================================
          WHY DNK
      ========================================================= */}

      <section className="dnk-why-section section-padding">

        <div className="container">

          <div className="row align-items-center">


            {/* LEFT */}

            <div
              className="col-lg-6 col-md-12"
              data-aos="fade-right"
            >

              <div className="section-title section__title_3 mb-30">

                <h6>
                  WHY DNK SOFTWARE
                </h6>

                <h2>
                  More Than A Vendor.
                  <br />
                  A Technology Partner.
                </h2>

              </div>

              <p>
                Successful software starts with understanding the
                business problem. We focus on creating solutions that
                are useful today and capable of growing with your
                organization tomorrow.
              </p>

              <Link
                to="/about"
                className="theme-btn mt-20"
              >
                Learn More About Us
                <i className="icon-arrow-right-1"></i>
              </Link>

            </div>


            {/* RIGHT */}

            <div
              className="col-lg-6 col-md-12 mt-40 mt-lg-0"
              data-aos="fade-left"
            >

              <div className="dnk-why-list">


                <div className="dnk-why-item">

                  

                  <div>

                    <h4>
                      Business Understanding
                    </h4>

                    <p>
                      We begin with your business challenge rather
                      than simply starting with technology.
                    </p>

                  </div>

                </div>


                <div className="dnk-why-item">

                  

                  <div>

                    <h4>
                      Practical Engineering
                    </h4>

                    <p>
                      We focus on reliable, maintainable and useful
                      software solutions.
                    </p>

                  </div>

                </div>


                <div className="dnk-why-item">

                 

                  <div>

                    <h4>
                      Flexible Engagement
                    </h4>

                    <p>
                      Work with us on a product, project, service
                      or extended technology team.
                    </p>

                  </div>

                </div>


                <div className="dnk-why-item">

                  

                  <div>

                    <h4>
                      Long-Term Partnership
                    </h4>

                    <p>
                      Our relationship can continue beyond the first
                      release through support and ongoing development.
                    </p>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* =========================================================
          FINAL CTA
      ========================================================= */}

      <section className="cta-banner style-3">

        <div className="container-fluid section-bg">

          <div className="cta-content">

            <div className="row align-items-center">

              <div className="col-xl-7 col-12 text-white text-center text-xl-left">

                <span
                  style={{
                    color: "#c99545",
                    fontWeight: "700",
                    letterSpacing: "2px",
                    fontSize: "14px",
                  }}
                >
                  LET'S BUILD SOMETHING USEFUL
                </span>

                <h1>
                  Have A Business Challenge?
                  <br />
                  Let's Build The Right Solution.
                </h1>

              </div>


              <div className="col-xl-5 col-12">

                <div className="btn-wraper d-flex flex-wrap justify-content-xl-end mt-4 mt-xl-0">

                  <Link
                    to="/contact"
                    className="theme-btn"
                  >
                    Start a Conversation
                    <i className="icon-arrow-right-1"></i>
                  </Link>

                  <Link
                    to="/products"
                    className="theme-btn"
                  >
                    Explore Products
                    <i className="icon-arrow-right-1"></i>
                  </Link>

                </div>

              </div>

            </div>

          </div>

        </div>

      </section>

    </div>
  );
};

export default Home;